<template>
  <div class="container" ref="container">
    <!-- :style="{ height: third && third.imgUrl ? '800px' : 'auto' }" -->
    <img
      class="img"
      @load="handleImgLoad($refs['container'], baseUrl + third.imgUrl)"
      v-if="third && third.imgUrl"
      :src="baseUrl + third.imgUrl"
    />

    <div v-if="third" class="j-container">
      <div class="j-title title">{{ third.title }}</div>

      <div class="img-container" v-if="third" v-html="third.articleTxt"></div>
    </div>

    <div class="img-container j-coming-soon j-content" v-if="loaded && !third">
      {{ $t('common.coming_soon') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'History',
  data() {
    return {
      baseUrl
    };
  },
  props: {
    third: {
      required: true,
      default: () => {
        return null;
      }
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleImgLoad(container, src) {
      if (container && src) {
        const img = new Image();
        img.src = src;
        const oriHeight = img.height;

        container.style.height = `${oriHeight}px`;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  z-index: 1;
  margin-bottom: 80px;

  .title {
    margin-bottom: 30px;
    text-align: center;
  }

  img {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>
